import React from 'react';
import { numberWithCommas, titleCase } from '../../../../utils/helpers';
import Image from '../../../common/image';

const MyPackagesTable = ({ cards, userClass }) => {
	return (
		<div className='table-responsive'>
			<table className='table table-sm table-borderless myTable text-center'>
				<thead>
					<tr>
						<th>#</th>
						<th>Card</th>
						<th>Amount</th>
						<th>Purchase Date</th>
						<th>Purchase Type</th>
						<th>Status</th>
						<th>Max Cap</th>
						<th>Used Max Cap</th>
					</tr>
				</thead>
				<tbody>
					{cards.map((card, key) => {
						const percentage = Number(
							((card.usedMaxCap * 100) / card.maxCap).toFixed(2)
						);
						return (
							<tr key={key}>
								<td>{card.no}</td>
								<td>
									<div className='d-flex align-items-center'>
										<Image
											height='50px'
											fileName={`diamonds/${card.card}.webp`}
											className='me-2'
										/>
										<div>{titleCase(`${card.card} ${userClass} Card`)}</div>
									</div>
								</td>
								<td>{'$' + numberWithCommas(card.amount / 1e6)}</td>
								<td> {new Date(card.date).toLocaleDateString()}</td>
								<td>{card.purchaseType}</td>
								<td>{card.status}</td>
								<td>
									{'$' + numberWithCommas(card.usedMaxCap / 1e6)} /{' '}
									{'$' + numberWithCommas(card.maxCap / 1e6)}{' '}
								</td>
								<td>
									<div>{`${percentage}%`}</div>
									<div className='d-flex justify-content-center align-items-center'>
										<span
											className='progress'
											title={`${percentage}%`}
											style={{
												width: '80px',
												height: '10px',
											}}>
											<div
												className='progress-bar'
												role='progressbar'
												aria-label='Max Cap'
												style={{
													width: `${percentage}%`,
												}}
												aria-valuenow={Number(percentage)}
												aria-valuemin='0'
												aria-valuemax='100'></div>
										</span>
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default MyPackagesTable;
